import { Component, inject } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';

import { ToastService } from '../../shared/services/app';

@Component({
  selector: 'app-toasts',
  standalone: true,
  imports: [NgbToastModule, NgTemplateOutlet],
  templateUrl: './toasts.component.html',
  styleUrls: ['./toasts.component.scss'],
  host: {
    class: 'toast-container position-fixed top-0 end-0 p-3',
  },
})
export class ToastsComponent {
  readonly toastService = inject(ToastService);
}
